module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/regenerator/index.js
// module id = 14
// module chunks = 2